if (!customElements.get('free-shipping')) {
  customElements.define(
    'free-shipping',
    class FreeShipping extends HTMLElement {
      constructor() {
        super()
      }
      connectedCallback() {
        document.addEventListener('cartchange', (e) => {
          this.total = e.detail?.cart?.total_price
        })
      }
    }
  )
}
